import { createOption } from '@mews-commander/ui';
import { SelectField } from '@mews-commander/form';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CashPaymentFormField } from './schema';
import { useGetCurrentProfileCashiersSuspense } from './hooks/useGetCurrentProfileCashiersSuspense';

export const CashPaymentCashiersSelect = () => {
    const { data = [] } = useGetCurrentProfileCashiersSuspense();

    return (
        <SelectField
            options={data.map(({ id, name }) => createOption({ value: id, label: name }))}
            name={CashPaymentFormField.CashierId}
            label={<LocalizedText textKey={TextKey.Cashier} />}
            required
        />
    );
};
